import { render, staticRenderFns } from "./questionnaireResulet.vue?vue&type=template&id=140471e4&scoped=true"
import script from "./questionnaireResulet.vue?vue&type=script&lang=js"
export * from "./questionnaireResulet.vue?vue&type=script&lang=js"
import style0 from "./questionnaireResulet.vue?vue&type=style&index=0&id=140471e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140471e4",
  null
  
)

export default component.exports